var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canFollow)?_c('a',{class:{ 'follow-button-yellow': _vm.followed },attrs:{"title":_vm.tooltip},on:{"click":_vm.onClick}},[_c('fa-icon',{attrs:{"icon":"star"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }